import React, { useState, useEffect, useContext } from "react";
import './rightDetails.scss';
import { PersonalDetails } from "./PersonalDetails";
import { Package } from "./Package";
import { Activity } from "./Activity";
import { Assessment } from "./Assessment";
import { AuthContext } from "../../context/AuthContext";
import candidateApi from "../../services/candidateApi";
import { useParams } from 'react-router-dom';
export const RightDetails = () => {
  let { id } = useParams();
  const [candidateData, setCandidateData] = useState(null);
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext); 
  const [selectedTab, setSelectedTab] = React.useState("PI");

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try{
    if (!id){
      id=candidateIdValue;
    }
    const response = await candidateApi.getCandidateById(id); // Call API with the ID
    if (response?.data) {
      setCandidateData(response.data); 
    }
  } catch (error) {
  }
  }


  return (
    <section className="candidate-details-right common-tab-container">
      <div className='tabMenu common-tab-nav d-flex mb-4'>
        <div
          className={`tabButton d-flex align-items-center ${selectedTab === "PI" ? "active" : ""}`}
          onClick={() => setSelectedTab("PI")} title="Package">
          <div className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16.465" height="12" viewBox="0 0 16.465 12">
              <path id="id-card-svgrepo-com" d="M16.18,5.25H2.785A1.537,1.537,0,0,0,1.25,6.785v8.93A1.537,1.537,0,0,0,2.785,17.25h13.4a1.537,1.537,0,0,0,1.535-1.535V6.785A1.537,1.537,0,0,0,16.18,5.25Zm-13.4.837h13.4a.7.7,0,0,1,.7.7v.7H2.087v-.7a.7.7,0,0,1,.7-.7Zm13.4,10.326H2.785a.7.7,0,0,1-.7-.7V8.32H16.878v7.4a.7.7,0,0,1-.7.7ZM5.936,12.159a1.471,1.471,0,1,0-1.471-1.471h0a1.472,1.472,0,0,0,1.471,1.471Zm0-2.1a.633.633,0,1,1-.633.633h0a.634.634,0,0,1,.633-.633Zm0,2.764a2.538,2.538,0,0,0-2.461,1.965l0,.017a.406.406,0,0,0-.009.089.418.418,0,0,0,.827.092v0a1.687,1.687,0,0,1,3.292-.011l0,.011a.419.419,0,0,0,.827-.091A.409.409,0,0,0,8.4,14.8v0a2.541,2.541,0,0,0-2.464-1.982h0Zm9.128-3.1H10.6a.419.419,0,1,0,0,.837h4.465a.419.419,0,0,0,0-.837Zm0,2.233H10.6a.419.419,0,1,0,0,.837h4.465a.419.419,0,0,0,0-.837Zm0,2.233H10.6a.419.419,0,1,0,0,.837h4.465a.419.419,0,0,0,0-.837Z" transform="translate(-1.25 -5.25)" fill="#0583d0" />
            </svg>

          </div>
          Personal Information
        </div>
        <div
          className={`tabButton d-flex align-items-center ${selectedTab === "package" ? "active" : ""}`}
          onClick={() => setSelectedTab("package")} title="Package">
          <div className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="11.993" height="12" viewBox="0 0 11.993 12">
              <g id="salary-wage-svgrepo-com" transform="translate(-71.677 -71.68)">
                <path id="Path_559" data-name="Path 559" d="M264.68,737.994a.14.14,0,0,0-.14-.14h-1.118a.14.14,0,0,0-.14.14v1.631h1.4Zm-1.957,2.19v-2.19a.7.7,0,0,1,.7-.7h1.118a.7.7,0,0,1,.7.7v2.19Z" transform="translate(-188.438 -656.529)" fill="#888" />
                <path id="Path_560" data-name="Path 560" d="M408.04,656.074a.14.14,0,0,0-.14-.14h-1.118a.14.14,0,0,0-.14.14v2.749h1.4Zm-1.957,3.308v-3.308a.7.7,0,0,1,.7-.7H407.9a.7.7,0,0,1,.7.7v3.308Z" transform="translate(-329.841 -575.728)" fill="#888" />
                <path id="Path_561" data-name="Path 561" d="M338.816,79.228a.14.14,0,0,0-.14-.14h-1.118a.14.14,0,0,0-.14.14V83.1h1.4Zm-1.957,4.426V79.228a.7.7,0,0,1,.7-.7h1.118a.7.7,0,0,1,.7.7v4.426ZM335.59,74.6l-1.1-2.16a.14.14,0,0,1,.125-.2h3.435a.14.14,0,0,1,.125.2l-1.1,2.16a.28.28,0,0,0,.5.253l1.1-2.16a.7.7,0,0,0-.623-1.015h-3.435a.7.7,0,0,0-.623,1.015l1.1,2.16a.28.28,0,0,0,.5-.253Z" transform="translate(-258.661)" fill="#888" />
                <path id="Path_562" data-name="Path 562" d="M80.6,291.569a2.516,2.516,0,0,0,2.516-2.516v-.589a4.907,4.907,0,0,0-4.892-4.892H77.128a4.907,4.907,0,0,0-4.892,4.892v.589a2.516,2.516,0,0,0,2.516,2.516Zm0,.559H74.752a3.075,3.075,0,0,1-3.075-3.075v-.589a5.466,5.466,0,0,1,5.451-5.451h1.091a5.466,5.466,0,0,1,5.451,5.451v.589A3.075,3.075,0,0,1,80.6,292.128Z" transform="translate(0 -208.448)" fill="#888" />
              </g>
            </svg>

          </div>
          Package
        </div>
        {candidateData?.candidatejobmapping?.length > 0 && (
        <div
          className={`tabButton d-flex align-items-center ${selectedTab === "Activity" ? "active" : ""}`}
          onClick={() => setSelectedTab("Activity")} title="Activity">
          <div className="icon stroke">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="12.306" viewBox="0 0 19 12.306">
              <path id="activity-svgrepo-com_1_" data-name="activity-svgrepo-com (1)" d="M21,14H18L15,7,10,17,7,11,5,14H3" transform="translate(-2.5 -5.812)" fill="none" stroke="#888" stroke-linecap="square" stroke-width="1" />
            </svg>


          </div>
          Activity
        </div>
        )}
        {candidateData?.candidatejobmapping?.length > 0 && (
        <div
          className={`tabButton d-flex align-items-center ${selectedTab === "Assessment" ? "active" : ""}`}
          onClick={() => setSelectedTab("Assessment")} title="Assessment">
          <div className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="10.34" height="12" viewBox="0 0 10.34 12">
              <g id="annual-assessment-svgrepo-com" transform="translate(-187.9 -64)">
                <path id="Path_563" data-name="Path 563" d="M193.009,75.464h-4.573V65h1.3a.7.7,0,0,0,.633.4H194.1a.7.7,0,0,0,.633-.4h1.293V71.13a.267.267,0,1,0,.535,0V64.887a.422.422,0,0,0-.425-.419h-1.374A.7.7,0,0,0,194.1,64h-3.733a.707.707,0,0,0-.662.468h-1.382a.422.422,0,0,0-.425.419V75.581a.422.422,0,0,0,.425.419h4.684a.268.268,0,0,0,0-.536Z" fill="#888" />
                <path id="Path_564" data-name="Path 564" d="M273.864,376.383a.268.268,0,0,0-.267-.267h-4.913a.4.4,0,1,0,.032.535H273.6A.268.268,0,0,0,273.864,376.383Zm0,1.839a.268.268,0,0,0-.267-.267h-4.872a.4.4,0,1,0-.051.535H273.6A.268.268,0,0,0,273.864,378.222Zm-5.167,1.585h-.012a.4.4,0,1,0,.029.535h3.975a.268.268,0,0,0,0-.535Zm8.428-1.755a.268.268,0,0,0-.361.114l-2.6,4.99-1.921-1.051a.267.267,0,0,0-.257.468l2.168,1.188a.268.268,0,0,0,.362-.106.286.286,0,0,0,.027-.071l2.691-5.169A.269.269,0,0,0,277.124,378.052Z" transform="translate(-79.029 -307.827)" fill="#888" />
                <path id="Path_565" data-name="Path 565" d="M274.1,201.906h-5.738a.358.358,0,0,1-.358-.358v-1.089a.358.358,0,0,1,.358-.358H274.1a.358.358,0,0,1,.358.358v1.089A.358.358,0,0,1,274.1,201.906Z" transform="translate(-79.029 -134.28)" fill="#888" />
              </g>
            </svg>
          </div>
          Assessment
        </div>
        )}

      </div>

      <div className='tabContent common-tab-content'>
        {selectedTab === "PI" && (
          <div className='tab-inner'>
            <PersonalDetails />
          </div>
        )}
        {selectedTab === "package" && (

          <div className='tab-inner'>
           
          <Package />
          </div>
        )}
        {selectedTab === "Activity" && (

          <div className='tab-inner list-holder'>
            <Activity />
          </div>
        )}
        {selectedTab === "Assessment" && (
          <div className='tab-inner'>           
          <Assessment />
          </div>
        )}
      </div>

    </section>
  );
}

